class customWidget extends HTMLElement {
  constructor() {
    super();
    this.handlePurchaseTypeChange = this.handlePurchaseTypeChange.bind(this);
    this.updateSellingPlanPrice = this.updateSellingPlanPrice.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.initWidget();
    document.addEventListener('click', this.handleOutsideClick);
  }

  disconnectedCallback() {
    this.removeWidgetEvents();
    document.removeEventListener('click', this.handleOutsideClick);
  }

  initWidget() {
    this.purchaseTypeInputs = this.querySelectorAll('input[name="purchase-type"]');
    this.quantityInputs = this.querySelectorAll('input[name="quantity"]');
    this.hiddenSelectInput = this.querySelector('.selected-selling-plan-id-esa');

    this.customSelectToggle = this.querySelector('.custom-select-toggle');
    this.customSelectOptionsContainer = this.querySelector('.custom-select-options');
    this.customSelectOptions = this.querySelectorAll('.custom-select-option');

    this.dataQuantityEnabled = this.getAttribute('data-quantity') !== 'false';
    this.isTrial = this.getAttribute('data-offer-trial') === 'true';

    this.oneTimeAtcText = this.getAttribute('data-ot-atc-text') || 'Add to cart';
    this.subAtcText = this.getAttribute('data-sub-atc-text') || 'Subscribe now';

    this.purchaseTypeInputs.forEach(input => {
      input.addEventListener('change', this.handlePurchaseTypeChange);
    });

    this.quantityInputs.forEach(input => {
      input.addEventListener('change', (e) => this.updateSellingPlanPrice(e));
    });

    if (this.customSelectToggle && this.customSelectOptions.length > 0) {
      this.customSelectToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        this.customSelectOptionsContainer.classList.toggle('open');
      });

      this.customSelectOptions.forEach(option => {
        option.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const value = option.getAttribute('data-value');
          const nameText = option.querySelector('.esa__plan-name')?.textContent?.trim();
          const saveText = option.querySelector('.esa__save-text')?.textContent?.trim();

          const toggleName = this.customSelectToggle.querySelector('.esa__plan-name');
          const toggleSave = this.customSelectToggle.querySelector('.esa__save-text');

          if (toggleName) toggleName.textContent = nameText;
          if (toggleSave) toggleSave.textContent = saveText;

          if (this.hiddenSelectInput) this.hiddenSelectInput.value = value;

          this.customSelectOptions.forEach(opt => opt.classList.remove('selected'));
          option.classList.add('selected');

          this.customSelectOptionsContainer.classList.remove('open');

          this.updateSellingPlanPrice();
        });
      });

      const selectedOption = this.querySelector('.custom-select-option.selected');
      if (selectedOption) {
        const nameText = selectedOption.querySelector('.esa__plan-name')?.textContent?.trim();
        const saveText = selectedOption.querySelector('.esa__save-text')?.textContent?.trim();

        const toggleName = this.customSelectToggle.querySelector('.esa__plan-name');
        const toggleSave = this.customSelectToggle.querySelector('.esa__save-text');

        if (toggleName) toggleName.textContent = nameText;
        if (toggleSave) toggleSave.textContent = saveText;
      }

      setTimeout(() => {
        var appInput = document.querySelector('product-form .selected-selling-plan-id');
        if (appInput) appInput.remove();
      }, 2000);
    }

    const initialSelection = this.querySelector('input[name="purchase-type"]:checked');
    if (initialSelection) this.handlePurchaseTypeChange({ target: initialSelection });
  }

  handleOutsideClick(event) {
    const isInside = this.contains(event.target);
    if (!isInside) {
      const openList = this.querySelector('.custom-select-options.open');
      if (openList) {
        openList.classList.remove('open');
      }
    }
  }

  removeWidgetEvents() {
    if (this.purchaseTypeInputs) {
      this.purchaseTypeInputs.forEach(input => {
        input.removeEventListener('change', this.handlePurchaseTypeChange);
      });
    }

    if (this.quantityInputs) {
      this.quantityInputs.forEach(input => {
        input.removeEventListener('change', this.updateSellingPlanPrice);
      });
    }
  }

  handlePurchaseTypeChange(event) {
    const selectedValue = event.target.value;
    const isOneTime = selectedValue === 'one-time';
    const isSubscribe = selectedValue === 'subscribe';

    const qtyWrap = this.querySelector('.qty-option-wrap');
    if (qtyWrap) {
      qtyWrap.classList.toggle('subscription__toggle', selectedValue === 'subscribe');
    }

    const atcButtons = this.querySelectorAll('.widget_add_button');
    atcButtons.forEach(button => {
      button.textContent = isOneTime
        ? this.oneTimeAtcText
        : this.subAtcText;
    });

    const hiddenInput = this.querySelectorAll('input.selected-selling-plan-id-esa');
    if (hiddenInput) {
      const subPrices = document.querySelectorAll(".subscription_selling_price");
      const onePrices = document.querySelectorAll(".oneTime_price");

      const subsSave = document.querySelectorAll(".per_item_disocuntPS");
      const oneSave = document.querySelectorAll(".per_item_disocuntPO");

      if (selectedValue === 'subscribe') {
        hiddenInput.forEach(val => {
          val.classList.add("subscribe_plan");
          val.removeAttribute("disabled");
        });
        subPrices.forEach(price => price.classList.add("show"));
        onePrices.forEach(price => price.classList.remove("show"));

        subsSave.forEach(priceS => priceS.classList.add("show"));
        oneSave.forEach(priceo => priceo.classList.remove("show"));
      } else {
        hiddenInput.forEach(val => {
          val.classList.remove("subscribe_plan");
          val.setAttribute("disabled", true);
        });
        onePrices.forEach(price => price.classList.add("show"));
        subPrices.forEach(price => price.classList.remove("show"));

        subsSave.forEach(priceS => priceS.classList.remove("show"));
        oneSave.forEach(priceo => priceo.classList.add("show"));
      }
    }

    this.toggleBenefits(isSubscribe);

    this.updateSellingPlanPrice();
  }

  toggleBenefits(isSubscribe) {
    const oneTimeBenefits = this.querySelectorAll('.one-time__benefits');
    const subBenefits = this.querySelectorAll('.subscription__benefits');

    oneTimeBenefits.forEach(el => {
      el.style.display = isSubscribe ? 'none' : 'block';
    });

    subBenefits.forEach(el => {
      el.style.display = isSubscribe ? 'block' : 'none';
    });
  }

  updateSellingPlanPrice(event) {
    const selectedPurchaseType = this.querySelector('input[name="purchase-type"]:checked')?.value;
    const selectedQtyInput = event?.target;
    const noscriptEl = document.getElementById('variant__json');
    if (!noscriptEl) return;

    const allCustomOptions = this.querySelectorAll('.custom-select-option');
    allCustomOptions.forEach(opt => opt.classList.remove('selected'));

    if (selectedQtyInput && selectedQtyInput.name === 'quantity') {
      this.quantityInputs.forEach(input => {
        if (input !== selectedQtyInput) {
          input.checked = false;
        }
      });
      selectedQtyInput.checked = true;
    }

    const qtyLabels = document.querySelectorAll('.qty-option-label');
    qtyLabels.forEach((label) => {
      label.addEventListener('click', () => {
        qtyLabels.forEach(l => l.classList.remove('active'));
        label.classList.add('active');
      });
    });

    if (selectedQtyInput?.checked) {
      const qtyLabel = selectedQtyInput.closest('.qty-option-label');
      if (qtyLabel) {
        const customOption = qtyLabel.querySelector('.custom-select-option');
        if (customOption) {
          customOption.classList.add('selected');
          const attr = customOption.getAttribute('data-value');
          console.log("attr data-value", attr);
        }
      }
    }

    const variantDataStr = noscriptEl.getAttribute('variant-data');
    if (!variantDataStr) return;

    const variantData = JSON.parse(variantDataStr);
    const sellingPlanId = this.hiddenSelectInput?.value;

    const compareAtPrice = variantData.compare_at_price || 0;
    const oneTimeBase = variantData.price || 0;

    const quantity = this.dataQuantityEnabled && selectedQtyInput
      ? parseInt(selectedQtyInput.value)
      : 1;

    const qtyDiscount = this.dataQuantityEnabled && selectedQtyInput
      ? parseFloat(selectedQtyInput.dataset.qtyDiscount || 0)
      : 0;

    let discountFactor = 1;
    if (this.dataQuantityEnabled) {
      discountFactor = 1 - qtyDiscount / 100;
    }

    let subUnitPrice = oneTimeBase;

    if (this.isTrial) {
      subUnitPrice = 0;
    } else if (sellingPlanId && variantData.selling_plan_allocations?.length) {
      const allocation = variantData.selling_plan_allocations.find(
        alloc => alloc.selling_plan_id == sellingPlanId
      );
      if (allocation?.price) {
        subUnitPrice = allocation.price;
      }
    }

    const oneTimeTotal = (oneTimeBase * discountFactor * quantity) / 100;
    const subTotal = (subUnitPrice * discountFactor * quantity) / 100;
    const compareTotal = (compareAtPrice * quantity) / 100;

    // --- Update subscription box ---
    const subscriptionBox = this.querySelector('.subscription-box.box-style');
    if (subscriptionBox) {
      const salePriceElement = subscriptionBox.querySelector('.sale_price_esa');
      const delElement = subscriptionBox.querySelector('.price del span');

      if (salePriceElement) salePriceElement.textContent = "$" + (this.isTrial ? "0.00" : subTotal.toFixed(2));
      if (delElement && !this.isTrial) delElement.textContent = "$" + compareTotal.toFixed(2);
    }

    // --- Update one-time box ---
    const oneTimeBox = this.querySelector('.one-time-box.box-style');
    if (oneTimeBox) {
      const salePriceElement = oneTimeBox.querySelector('.sale_price_esa');
      const delElement = oneTimeBox.querySelector('.price del span');

      if (salePriceElement) salePriceElement.textContent = "$" + oneTimeTotal.toFixed(2);
      if (delElement) delElement.textContent = "$" + compareTotal.toFixed(2);
    }

    // --- Update button price ---
    const submitButton = document.querySelector('.product-form__submit');
    if (submitButton) {
      const priceWrapper = submitButton.querySelector('.price');
      const priceContainer = priceWrapper?.querySelector('.price__container');

      if (priceWrapper && priceContainer) {
        const hasCompareAt = compareAtPrice > 0 && compareAtPrice !== oneTimeBase;

        const regularWrapper = priceWrapper.querySelector('.price__regular');
        const saleWrapper = priceWrapper.querySelector('.price__sale');

        const finalDisplayPrice = selectedPurchaseType === 'subscribe'
          ? (this.isTrial ? 0 : subTotal)
          : oneTimeTotal;

        if (hasCompareAt) {
          if (saleWrapper) {
            const salePriceEl = saleWrapper.querySelector('.price-item--sale');
            const comparePriceEl = saleWrapper.querySelector('.price-item--regular');

            if (salePriceEl) salePriceEl.textContent = "$" + finalDisplayPrice.toFixed(2);
            if (comparePriceEl) comparePriceEl.textContent = "$" + compareTotal.toFixed(2);
          }
          if (regularWrapper) regularWrapper.style.display = 'none';
          if (saleWrapper) saleWrapper.style.display = '';
        } else {
          if (regularWrapper) {
            const regularPriceEl = regularWrapper.querySelector('.price-item--regular');
            if (regularPriceEl) {
              regularPriceEl.textContent = "$" + finalDisplayPrice.toFixed(2);
            }
            regularWrapper.style.display = '';
          }
          if (saleWrapper) saleWrapper.style.display = 'none';
        }
      }
    }
  }

  resetWidgetState() {
    const oneTimeRadio = this.querySelector('input[value="one-time"]');
    const subscribeRadio = this.querySelector('input[value="subscribe"]');
    const sellingPlanInput = this.querySelector('input.selected-selling-plan-id-esa');
    const select = this.querySelector('.frequency__select-box');

    if (oneTimeRadio) oneTimeRadio.checked = true;
    if (subscribeRadio) subscribeRadio.checked = false;
    if (sellingPlanInput) {
      sellingPlanInput.disabled = true;
      sellingPlanInput.value = '';
    }

    if (select) select.selectedIndex = 0;
  }
}

customElements.define('custom-widget', customWidget);